<template>
    <div class="echarts">
        <mini-chart
            :points="points"
            :plotShadow="true"
            :margin="{ top: 0, right: 0, bottom: 0, left: 0 }"
            :fixedWidth="this.chartWidth"
            :fixedHeight="this.chartHeight"
            :smooth="false"
        />
    </div>
</template>

<script>
import MiniChart from '../ui-components/ui-mini-linechart.vue';
import { mapGetters } from "vuex";
import Vue from "vue";

export default {
    components: {
        'mini-chart': MiniChart
    },
    props: {
        symbol: { default: '' },
        interval: { default: 1000000 },
        chartWidth:{default:348},
        chartHeight:{default:84}
    },
    data() {
        return {
            points: []
        };
    }, // data }
    computed: {
        ...mapGetters({
              getStatistics: 'accountstat/getStatistics'
        })
    },
    methods: {
        updateChart(symbol) {
            if (!symbol) symbol = this.symbol;
            let stat = this.getStatistics(symbol);
            if (!stat)
                return;            
            
            this.buildPoints(stat);
            // TODO: не дочерний компонент дожен эмитить это событие
            this.$emit('onStatisticReady', symbol)
        },
        buildPoints(stat) {
            let data = stat.DailyRecords;
            let points = [];
            let xStep = data.length < 100 ? 1 : data.length < 200 ? 2 : 
                Math.round(data.length / 200);
            for (let i = 0; i < data.length; i += xStep)
                points.push(data[i].EquityClose);
            this.points = points;
        }
    },
    watch: {
        symbol: function(val) {
            this.$store.dispatch("accountstat/unsubscribeFromUpdate", this.symbol);
            if (!this.symbol || !this.symbol.length) 
                return;
            subscribeOnUpdate(this.$store, val, isFirstObtained => {
                this.updateChart();
            });
            this.updateChart(val);
        }
    },
    // hooks
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            if (!this.symbol || !this.symbol.length)
                this.updateChart();
        });
        // может быть, данные уже есть в store
        this.updateChart();
    } // created }
}

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: `profit-chart-simple-${symbol}`,
            handler: handler
        }
    });
}
</script>

<style scoped>
.echarts {
    min-width: 100%;
    min-height: 100%;
}
</style>
